import React, { Component } from 'react';
import { Col, } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import renderSelectField from '../../../../../shared/components/form/Select';
import renderRadioButtonField from '../../../../../shared/components/form/RadioButton';

class Ananmesis extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cause: "",
            reasonForConsultation: "",
            currentIllness: "",
            load: false,
            candidate: "",
            acronym: ""
        };
    }
    /*componentDidMount() {
        this.setState({ load: true }, ()=>{
          this.props.loadAnamesis().then((load) => {
            this.setState({ load: load },()=>{
                console.log("cargar anamesis");
            });
          }).catch((error)=>{
            console.log(error)
          });
        })    
    }*/

    render() {
        return (<Col>
            <div className="form" style={{ flex: 1, flexDirection: 'column', marginBottom: 100 }}>
                <div className="card__title">
                    <h5 className="bold-text">Anamnesis</h5>
                </div>
                <div style={{ flex: 1, flexDirection: 'row', display: 'flex' }}>
                    <div className="form__form-group" style={{ margin: 10 }}>
                        <span className="form__form-group-label">Causa de Ingreso</span>
                        <div className="form__form-group-field">
                            <Field
                                className="cause-of-admission"
                                name="cause-of-admission"
                                component={renderSelectField}
                                options={[
                                    { value: 'Enfermedad general', label: 'Enfermedad general' },
                                    { value: 'Accidente de trabajo', label: 'Accidente de trabajo' },
                                    { value: 'Accidente de transito', label: 'Accidente de transito' },
                                    { value: 'Accidente ofidico', label: 'Accidente ofidico' },
                                    { value: 'Enfermedad professional', label: 'Enfermedad professional' },
                                    { value: 'Evento catastrofico', label: 'Evento catastrofico' },
                                    { value: 'Lesion auto infligida', label: 'Lesion auto infligida' },
                                    { value: 'Lesion por agresion', label: 'Lesion por agresion' },
                                    { value: 'Otra', label: 'Otra' },
                                    { value: 'Otro tipo de accidente', label: 'Otro tipo de accidente' },
                                    { value: 'Sospecha abuso sexual', label: 'Sospecha abuso sexual' },
                                    { value: 'Sospecha maltrato emocional', label: 'Sospecha maltrato emocional' },
                                    { value: 'Sospecha maltrato fisico', label: 'Sospecha maltrato fisico' },
                                    { value: 'Sospecha violencia sexual', label: 'Sospecha violencia sexual' },
                                ]}
                                value={this.props.anamesis.cause}
                                onChange={(e) => {
                                    this.props.handlerSelectCauseOfAdmission(e.value)
                                }}
                            />
                        </div>
                    </div>
                    <div className="form__form-group" style={{ margin: 10 }}>
                        <span className="form__form-group-label">Motivo de Consulta</span>
                        <div className="form__form-group-field">
                            <Field
                                name="textarea-reason-for-consultation"
                                component="textarea"
                                type="text"
                                value={this.props.anamesis.reasonForConsultation}
                                onChange={(e) => {
                                    this.props.handlerReasonForConsultation(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                    <div className="form__form-group" style={{ margin: 10 }}>
                        <span className="form__form-group-label">Enfermedad Actual</span>
                        <div className="form__form-group-field">
                            <Field
                                name="textarea-current-illness"
                                component="textarea"
                                type="text"
                                value={this.props.anamesis.currentIllness}
                                onChange={(e) => {
                                    this.props.handlerCurrentIllness(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className="form__form-group">
                    <span className="form__form-group-label">El paciente es candidato a participar en el Estudio Clínico</span>
                    <div className="form__form-group-field">
                        <Field
                            name="radio_button-candiate"
                            component={renderRadioButtonField}
                            label="Sí"
                            radioValue={"Sí"}
                            defaultChecked={this.props.anamesis.candidate}
                            onChange={(e) => {
                                this.setState({ candidate: "Sí" });
                                this.props.handlerCandidate(e);
                            }}
                        />
                        <Field
                            name="radio_button-candiate"
                            component={renderRadioButtonField}
                            label="No"
                            radioValue={"No"}
                            defaultChecked={!this.props.anamesis.candidate}
                            onChange={(e) => {
                                this.setState({ candidate: "No" });
                                this.props.handlerCandidate(e);
                            }}
                        />
                    </div>
                </div>
                {this.state.candidate === "Sí" ?
                    <div className="form">
                        <div className="form__form-group" style={{ width: '40%', }}>
                            <span className="form__form-group-label">Acrónimo del Estudio</span>
                            <div className="form__form-group-field">
                                {/*<h4>{this.props.acronym}</h4>*/}
                                <Field
                                    name="acronym"
                                    component={renderSelectField}
                                    options={[
                                        { value: 'SIN ESTUDIO CLINICO', label: 'SIN ESTUDIO CLINICO' },
                                        { value: 'APD334-202', label: 'APD334-202' },
                                        { value: 'APD334-302', label: 'APD334-302' },
                                        { value: 'APD334-303', label: 'APD334-303' },
                                        { value: 'APD334-301', label: 'APD334-301' },
                                        { value: 'PA', label: 'PA' },
                                        { value: 'HORIZON', label: 'HORIZON' },
                                        { value: 'PARADISE-MI', label: 'PARADISE-MI' },
                                        { value: 'PARALLAX', label: 'PARALLAX' },
                                        { value: 'TQJ230', label: 'TQJ230' },
                                        { value: 'RESOLUTE', label: 'RESOLUTE' },
                                        { value: 'PONENTE', label: 'PONENTE' },
                                        { value: 'DISCOVER', label: 'DISCOVER' },
                                    ]}
                                    //value={this.props.anamesis.cause}
                                    onChange={(e) => {
                                        //this.props.handlerSelectCauseOfAdmission(e.value)
                                    }}
                                />
                            </div>
                        </div>
                        <div className="form__form-group" style={{ width: '40%', marginLeft: 30, marginTop: 10 }}>
                            <span className="form__form-group-label">El paciente es desea participar en el Estudio Clínico</span>
                            <div className="form__form-group-field">
                                <Field
                                    name="radio_button-participate"
                                    component={renderRadioButtonField}
                                    label="Sí"
                                    radioValue={"Sí"}
                                    defaultChecked={this.props.anamesis.participate}
                                    onChange={(e) => {
                                        this.props.handlerParticipate(e);

                                    }}
                                />
                                <Field
                                    name="radio_button-participate"
                                    component={renderRadioButtonField}
                                    label="No"
                                    radioValue={"No"}
                                    defaultChecked={!this.props.anamesis.participate}
                                    onChange={(e) => {
                                        this.props.handlerParticipate(e);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    : null}
            </div>
        </Col>);
    }
}

export default reduxForm({
    form: `ananmesis-form`, // a unique identifier for this form
})(withTranslation('common')(Ananmesis));